import { action, computed, observable } from 'mobx'

import Filter from '../Filter'

class FilterStore {
  @observable
  filters = observable.map()

  // This holds hitlist data pertaining to filters.
  @observable
  data = observable.map()

  @action
  addFilter(name, cb) {
    const filter = new Filter(name, cb)
    this.filters.set(name, filter)
  }

  @action
  removeFilter(name) {
    this.filters.delete(name)
  }

  @action
  clearFilters() {
    this.filters.clear()
  }

  @action
  disableFilter(name) {
    this.setFilterStatus(name, false)
  }

  @action
  enableFilter(name) {
    this.setFilterStatus(name, true)
  }

  @action
  setFilterStatus(name, isEnabled) {
    const filter = this.filters.get(name)
    if (filter) {
      filter.setIsEnabled(isEnabled)
    }
  }

  isFilterEnabled(name) {
    return this.filters.has(name) && this.filters.get(name).isEnabled
  }

  @action
  setData(data) {
    this.data = observable.map(data)
  }

  @computed
  get enabledFilterCount() {
    let count = 0
    this.filters.forEach((filter) => {
      if (filter.isEnabled) count++
    })
    return count
  }

  applyFilters(ids, options = { skip: [] }, filters = this.filters.values()) {
    // Copy the id and filter arrays.
    let filteredIds = [...ids]
    const localFilters = [...filters]
    const filter = localFilters.shift()

    if (!options.skip) options.skip = []

    if (filter && filter.isEnabled) {
      // Filter the IDs if we aren't supposed to skip it.
      if (
        options.skip.length === 0 ||
        options.skip.indexOf(filter.name) === -1
      ) {
        filteredIds = filter.apply(ids, options)
      }
      return this.applyFilters(filteredIds, options, localFilters)
    }
    return filteredIds
  }
}

export default FilterStore
